<template>
  <div class="formcell">
    <div v-if="labelText" class="label">
      <slot>
        {{ labelText }}
      </slot>
      <span v-if="required" class="required">*</span>
    </div>
    <v-select
      :value="value"
      outlined
      dense
      height="48"
      :item-value="itemValue"
      :item-text="itemText"
      :hide-details="hideDetails"
      :menu-props="{ offsetY: true }"
      class="vuetify-select"
      :items="items"
      @input="(e) => $emit('input', e)"
    >
      <template v-slot:append>
        <Icon type="chevron-down" color="secondary" size="20" />
      </template>
    </v-select>
  </div>
</template>

<script>
  import { VSelect } from 'vuetify/lib';
  import Icon from '@/components/ui/Icon';

  export default {
    name: 'Select',
    components: {
      VSelect,
      Icon,
    },
    model: {
      prop: 'value',
      event: 'input',
    },
    created() {
      this.$nextTick(() => {
        if (!this.value && this.items[0]) {
          this.$emit('input', this.items[0][this.itemValue]);
        }
      });
    },
    props: {
      labelText: {
        type: String,
        default: '',
      },
      /**
       * Is select required?
       */
      required: {
        type: Boolean,
        default: false,
      },
      hideDetails: {
        type: Boolean,
        default: true,
      },
      /**
       * Example:
       * [{
       *   value: 'en',
       *   text: 'English'
       * }]
       */
      items: {
        type: Array,
        default: () => [],
      },
      /**
       * Selected value
       */
      value: {
        type: [String, Object, Number],
        default: '',
      },
      /**
       * Value key
       */
      itemValue: {
        type: String,
        default: 'value',
      },
      /**
       * Text key
       */
      itemText: {
        type: String,
        default: 'text',
      },
    },
  };
</script>
